// tslint:disable: indent
// tslint:disable: no-console

import { v4 as uuidv4 } from 'uuid';
import { getGaClientId } from '../../../helpers/gtm';
import { collectMktoUtms, getMktoCookie, updateTaGtmEvent } from './ta-utils';

export interface TaNewUserObject {
    email: string;
    fullName: string;
    company: string;
}

export interface TaUserObject {
    email: string;
    fullName: string;
    company: string;
    step?: number;
    answers?: string[];
    _id?: string;
    initTime?: number;
    gacid?: string;
    visitorClientID?: string;
}

const BASE_URL = 'https://www.customerexperiencefestival.com/_functions-dev';
const GET_STATE = 'getStatebyParam';
const MKTO_CHECKUP = 'mktoCheckup';

export const getStateByParam = async (param: string, value: string) => {
    try {
        const res = await fetch(`${BASE_URL}/${GET_STATE}/${param}/${value}`);
        const data = await res.json();
        return data.user;
    } catch (err) {
        console.log('something went wrong: ', err);
    }
};

export const mktoCheckup = async (body: string, trigger: number) => {
    const enBody = btoa(body);
    try {
        const res = await fetch(`${BASE_URL}/${MKTO_CHECKUP}/${trigger}/${enBody}`);
        const data = await res.json();
        return data;
    } catch (err) {
        console.log('something went wrong: ', err);
    }
};

// LOCAL STORAGE FUNCTIONALITY

export const getLocalState = async () => {
    try {
        const str = localStorage.getItem('waTaState') || '';
        const state = JSON.parse(str);
        return Promise.resolve(state);
    } catch (err) {
        return '';
    }
};

export const addLocalState = async (body: TaUserObject) => {
    const newId = uuidv4();
    const time = new Date().getTime();
    const gacid = getGaClientId() || '';
    const visitorClientID = getMktoCookie('_ansPAID') || '';
    body.initTime = time;
    body.step = 0;
    body.answers = [];
    body._id = newId;
    body.gacid = gacid;
    body.visitorClientID = visitorClientID;
    const strBody = JSON.stringify(body);
    try {
        localStorage.setItem('waTaState', strBody);
        const mktoUtms = collectMktoUtms();
        const mktoCookie = getMktoCookie();
        const mktoCookieObj =  mktoCookie ? {cookie: mktoCookie} : {};
        const mktoBody = {...body, mktoUtms, ...mktoCookieObj};
        const strMktoBody = JSON.stringify(mktoBody);
        await mktoCheckup(strMktoBody, 1);
        updateTaGtmEvent('started');
        return Promise.resolve(body);
    } catch (err) {
        console.log(err);
        return Promise.resolve(body);
    }
};

export const updateLocalState = async (body: TaUserObject) => {
    const strBody = JSON.stringify(body);
    try {
        localStorage.setItem('waTaState', strBody);
    } catch (err) {
        alert('Browser does not support local storage');
    }
};

export const updateMktoActivity = async (activity: string) => {
    if (activity === 'DROP') {
        const strBody = localStorage.getItem('waTaState');
        if (strBody) {
            updateTaGtmEvent('dropped');
            mktoCheckup(strBody, 2);
        }
    }
    if (activity === 'END') {
        const body = await getLocalState();
        const strBody = JSON.stringify(body);
        updateTaGtmEvent('completed');
        await mktoCheckup(strBody, 3);
    }
};
